import { render, staticRenderFns } from "./CustomMainModal.vue?vue&type=template&id=56c7a34a&scoped=true"
import script from "./CustomMainModal.vue?vue&type=script&lang=js"
export * from "./CustomMainModal.vue?vue&type=script&lang=js"
import style0 from "./CustomMainModal.vue?vue&type=style&index=0&id=56c7a34a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c7a34a",
  null
  
)

export default component.exports